import { AnyAction } from '@reduxjs/toolkit';
import { GetRolesRoutine, UpdateRoleRoutine, DeleteRoleRoutine } from '~modules/Auth/redux-routines';
import { IRolesState } from '../interfaces';

export const initialState: IRolesState = {
  data: {},
  error: null,
  isFetching: false,
};

export const rolesReducer = (
  state: IRolesState = initialState,
  action: AnyAction,
): IRolesState => {
  switch (action.type) {
    case GetRolesRoutine.REQUEST:
    case UpdateRoleRoutine.REQUEST:
    case DeleteRoleRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GetRolesRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetRolesRoutine.FAILURE:
    case UpdateRoleRoutine.FAILURE:
    case DeleteRoleRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
